<ng-container #container></ng-container>
<div class="cn-box">
    <span class="hanja-txt"
          [class.selected]="chars[0] === selected">{{ chars[0] }}</span>
    <span class="sub"
          *ngIf="chars.length > 1">
          <ng-container *ngFor="let char of chars.slice(1); let i = index">
              <br *ngIf="(i + 1) % 2 === 0">
              <span class="hanja-txt"
                    [class.selected]="char === selected">{{ char }}</span>
          </ng-container>
    </span>
</div>
